export const deliveryStatusKeys = {
  DRAFT: {
    icon: {
      color: '#344264',
      backgroundColor: '#F0F2F6',
      chartColor: '#DEE1EA',
      variant: 'icon-outline_file-text',
    },
    text: 'Draf',
  },
  CONFIRMED: {
    icon: {
      color: '#0D4491',
      backgroundColor: '#CFDAE9',
      chartColor: '#0D4491',
      variant: 'icon-outline_submitted',
    },
    text: 'Dikonfirmasi',
  },
  SCHEDULED: {
    icon: {
      color: '#8F49DE',
      backgroundColor: '#F4EDFC',
      chartColor: '#A56DE5',
      variant: 'icon-outline_scheduler',
    },
    text: 'Dijadwalkan',
  },
  STARTED: {
    icon: {
      color: '#1C74DA',
      backgroundColor: '#DEEAFC',
      chartColor: '#478EE1',
      variant: 'icon-outline_truck-moving mc-fa',
    },
    text: 'Dijalankan',
  },
  PICKED: {
    icon: {
      color: '#FF8A00',
      backgroundColor: '#FFF3E6',
      chartColor: '#FFA133',
      variant: 'icon-outline_loading',
    },
    text: 'Diambil',
  },
  RESCHEDULED: {
    icon: {
      color: '#CC1D92',
      backgroundColor: '#F5D2E9',
      chartColor: '#D64AA8',
      variant: 'icon-outline_scheduler',
    },
    text: 'Dijadwalkan Ulang',
  },
  DELIVERED: {
    icon: {
      color: '#137C55',
      backgroundColor: '#E7F2EE',
      variant: 'icon-fill_checkmark-circle-2',
    },
    text: 'Terkirim',
  },
  CANCELED: {
    icon: {
      color: '#F64A33',
      backgroundColor: '#FEE8E5',
      variant: 'icon-outline_close-circle',
    },
    text: 'Dibatalkan',
  },
  WAITING_FOR_VENDOR: {
    icon: {
      color: '#344264',
      backgroundColor: '#EBECEF',
      variant: 'icon-outline_clock',
      chartColor: '#344264',
    },
    text: 'Menunggu Vendor',
  },
  REJECTED_BY_VENDOR: {
    icon: {
      color: '#921100',
      backgroundColor: '#FEE8E5',
      variant: 'icon-outline_close-square',
      chartColor: '#921100',
    },
    text: 'Ditolak Vendor',
  },
  ACCEPTED_BY_VENDOR: {
    icon: {
      color: '#0B4A33',
      backgroundColor: '#E7F2EE',
      variant: 'icon-outline_checkmark-square',
      chartColor: '#0B4A33',
    },
    text: 'Diterima Vendor',
  },
}
